export default __webpack_public_path__ + "static/media/iris-feat-logo.23f17cd1.png";